module.exports = __webpack_public_path__ + "fonts/agatho-webfont.ba1a8908.woff";